var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.763,
    height: 20.031,
    viewBox: "0 0 22.763 20.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "list",
    d: "M3,7.732A2.732,2.732,0,1,0,5.732,5,2.732,2.732,0,0,0,3,7.732m8.195-1.821H25.763V9.553H11.195ZM3,15.016a2.732,2.732,0,1,0,2.732-2.732A2.732,2.732,0,0,0,3,15.016m8.195-1.821H25.763v3.642H11.195ZM3,22.3a2.732,2.732,0,1,0,2.732-2.732A2.732,2.732,0,0,0,3,22.3m8.195-1.821H25.763v3.642H11.195Z",
    transform: "translate(-3 -5)",
    fill: "#00d297"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListActive);
export default __webpack_public_path__ + "static/media/list-active.d1a7e29217a858ef3a3145b791e73d0f.svg";
export { ForwardRef as ReactComponent };